import { TerminalLog } from '../models';

export class GetTerminalLogs {
    static readonly type = '[TerminalLog] get terminal logs';
    constructor(public payload: TerminalLog.TerminalLogListRequest) {

    }
}

export class DeleteTerminalLog {
    static readonly type = '[TerminalLog] delete terminal log';
    constructor(public id: string) {

    }
}
